import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Buying from './pages/Buying';
import Shipping from './pages/Shipping';
import Receiving from './pages/Receiving';
import Inventory from './pages/Inventory';
import Invoicing from './pages/Invoicing';
import Events from './pages/Events';
import UserManagement from './pages/UserManagement';

function App() {
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('buying');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div>
        <nav>
          <div className="nav-content">
            <div className="nav-title">WildOakHome OpsHub</div>
            <div className="nav-links">
              {user.role === 'admin' && (
                <Link
                  to="/buying"
                  className={currentPage === 'buying' ? 'active' : ''}
                  onClick={() => setCurrentPage('buying')}
                >
                  Buying
                </Link>
              )}
              {user.role === 'admin' && (
                <Link
                  to="/shipping"
                  className={currentPage === 'shipping' ? 'active' : ''}
                  onClick={() => setCurrentPage('shipping')}
                >
                  Shipping
                </Link>
              )}
              <Link
                to="/receiving"
                className={currentPage === 'receiving' ? 'active' : ''}
                onClick={() => setCurrentPage('receiving')}
              >
                Receiving
              </Link>
              <Link
                to="/inventory"
                className={currentPage === 'inventory' ? 'active' : ''}
                onClick={() => setCurrentPage('inventory')}
              >
                Inventory
              </Link>
              <Link
                to="/invoicing"
                className={currentPage === 'invoicing' ? 'active' : ''}
                onClick={() => setCurrentPage('invoicing')}
              >
                Invoicing
              </Link>
              <Link
                to="/events"
                className={currentPage === 'events' ? 'active' : ''}
                onClick={() => setCurrentPage('events')}
              >
                Events
              </Link>
              {user.role === 'admin' && (
                <Link
                  to="/users"
                  className={currentPage === 'users' ? 'active' : ''}
                  onClick={() => setCurrentPage('users')}
                >
                  Users
                </Link>
              )}
              <button onClick={handleLogout}>
                Logout ({user.username})
              </button>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/buying" element={<Buying user={user} />} />
          <Route path="/shipping" element={<Shipping user={user} />} />
          <Route path="/receiving" element={<Receiving user={user} />} />
          <Route path="/inventory" element={<Inventory user={user} />} />
          <Route path="/invoicing" element={<Invoicing user={user} />} />
          <Route path="/events" element={<Events user={user} />} />
          <Route path="/users" element={<UserManagement user={user} />} />
          <Route
            path="/"
            element={
              <Navigate to={user.role === 'admin' ? '/buying' : '/receiving'} replace />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
